import {
  Grid,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Radio,
  useEventCallback,
} from '@mui/material';
import { TypeInitiative } from 'practice/constants/practice-management-step';
import { memo } from 'react';

interface ContetTemporaryComponentProps {
  onChange: (value: TypeInitiative, typePractice?: string) => void;
  typeSelected?: TypeInitiative;
}

const ContetTemporaryComponent = ({
  typeSelected,
  onChange,
}: ContetTemporaryComponentProps): React.ReactElement => {
  const onChangeRadioPTR = useEventCallback(() => {
    onChange(TypeInitiative.idPersonaLegittima, 'PTR');
  });

  const onChangeRadioDOM = useEventCallback(() => {
    // persona
    onChange(TypeInitiative.idPersonaLegittima, 'DOM');
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="iniziativa"
            id="typeInitiative"
            value={typeSelected || 'PTR'}
            onChange={(event) => {
              if (event.target.value === 'PTR') {
                onChangeRadioPTR();
              } else {
                onChangeRadioDOM();
              }
            }}
          >
            <FormControlLabel value="PTR" control={<Radio />} label="Residenza temporanea" />
            <FormControlLabel
              value="DOM"
              control={<Radio />}
              label="Domicilio per rilascio carta di identità"
            />
          </RadioGroup>
        </FormControl>
      </Grid>
    </Grid>
  );
};

ContetTemporaryComponent.displayName = 'Content Temporary';

const ContetTemporary = memo(ContetTemporaryComponent);

export default ContetTemporary;
